export default __webpack_public_path__ + "static/media/Honored Gauntlets of the Far Horizon.d62adcef.jpg";